module.exports = __webpack_public_path__ + "img/arrow-right.5b7e9760.svg";